import script from "./liveImgList.vue?vue&type=script&setup=true&lang=js"
export * from "./liveImgList.vue?vue&type=script&setup=true&lang=js"

import "./liveImgList.vue?vue&type=style&index=0&id=b6ab01d6&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ab01d6"]])

export default __exports__